import { useEffect } from 'react';

interface SEOHeadProps {
  structuredData?: object;
}

export default function SEOHead({ structuredData }: SEOHeadProps) {
  useEffect(() => {
    if (structuredData) {
      // Remove existing structured data script if any
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript) {
        existingScript.remove();
      }

      // Add new structured data
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(structuredData);
      document.head.appendChild(script);

      return () => {
        script.remove();
      };
    }
  }, [structuredData]);

  return null;
}
